import React from 'react';
import { AuthProvider } from '../../features/auth/context/AuthContext';
import { BorrowerProvider } from '../../features/borrower/context/BorrowerContext';
import { BrokerProvider } from '../../features/broker/context/BrokerContext';
import { AdminProvider } from '../../features/admin/context/AdminContext';
import { OnboardingProvider } from '../../features/onboarding/context/OnboardingContext';
import { LoanProvider } from '../../features/onboarding/context/LoanContext';
import { OwnershipProvider } from '../../features/onboarding/context/OwnershipContext';
import { ErrorBoundary } from '../../shared/components/ErrorBoundary';

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BorrowerProvider>
          <BrokerProvider>
            <AdminProvider>
              <OnboardingProvider>
                <LoanProvider>
                  <OwnershipProvider>
                    {children}
                  </OwnershipProvider>
                </LoanProvider>
              </OnboardingProvider>
            </AdminProvider>
          </BrokerProvider>
        </BorrowerProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};
